import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import HistoryContext from '../context/historyContext';

const RouteHistory = function ({ children }) {
  const records = useRef({}).current;
  const historyPointer = useRef('global');
  const [currentHistory, setCurrentHistory] = useState([]);
  const route = useLocation();
  const setHistoryPointer = useCallback((value) => {
    historyPointer.current = value;
  }, []);
  const context = useMemo(
    () => ({
      setHistoryPointer,
      records,
      history: currentHistory,
    }),
    [currentHistory, records, setHistoryPointer],
  );

  useEffect(() => {
    const key = historyPointer.current;
    records[key] = records[key] || [];
    const history = records[key];

    const currentRouteIndex = window.history.state?.idx ?? null;
    const lastRouteIndex = history.at(-1)?.idx ?? null;

    if (currentRouteIndex < lastRouteIndex) {
      history.pop();
    }

    if (currentRouteIndex > lastRouteIndex || lastRouteIndex === null) {
      const { search, pathname } = route;

      history.push({
        pathname: `${pathname}${search}`,
        idx: currentRouteIndex,
      });
    }

    setCurrentHistory([...history]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route]);

  return <HistoryContext value={context}>{children}</HistoryContext>;
};

RouteHistory.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RouteHistory;
